export const version = "hash/5.0.9";
//# sourceMappingURL=_version.js.map